export default "__VITE_ASSET__CdlaXto0__"